"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var renderIcon_1 = require("./renderIcon");
var context_1 = require("./context");
var NodeLabel = function (_a) {
    var node = _a.node;
    var _b = (0, react_1.useState)(false), isOverflowing = _b[0], setIsOverflowing = _b[1];
    var _c = (0, context_1.useTreeContext)(), iconSelector = _c.iconSelector, iconPosition = _c.iconPosition;
    var ref = (0, react_1.useRef)(null);
    var positionIcon = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = node.iconPosition) !== null && _a !== void 0 ? _a : (iconPosition || 'left');
    }, [node.iconPosition]);
    (0, react_1.useEffect)(function () {
        if (ref.current) {
            if (ref.current.offsetWidth < ref.current.scrollWidth ||
                ref.current.offsetHeight < ref.current.scrollHeight) {
                setIsOverflowing(true);
            }
            else {
                setIsOverflowing(false);
            }
        }
    }, [ref.current]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "d-flex align-items-center flex-grow-1" }, { children: [positionIcon === 'left' &&
                (0, renderIcon_1.renderIcon)({ Icon: node.Icon, node: node, iconSelector: iconSelector, position: 'left' }), (0, jsx_runtime_1.jsx)("div", __assign({ ref: ref, className: "tree-label text-default me-auto", id: "node-label-".concat(node.id) }, { children: node.label })), positionIcon === 'right' &&
                (0, renderIcon_1.renderIcon)({
                    Icon: node.Icon,
                    node: node,
                    iconSelector: iconSelector,
                    position: 'right',
                }), node.badgeText && ((0, jsx_runtime_1.jsx)(reactstrap_1.Badge, __assign({ color: "neutral-subtle", className: "ms-3", pill: true, "data-testid": "tree-node-badge-".concat(node.id) }, { children: node.badgeText }))), node.notificationCount && ((0, jsx_runtime_1.jsx)("span", __assign({ className: "tree-node-notification ms-3 flex-shrink-0", "data-testid": "test-node-notification-".concat(node.id) }, { children: node.notificationCount }))), isOverflowing && ((0, jsx_runtime_1.jsx)(reactstrap_1.UncontrolledTooltip, __assign({ target: "node-label-".concat(node.id) }, { children: node.label })))] })));
};
exports.NodeLabel = NodeLabel;
